export const ALIGN_TYPES: any = {
    ALIGN_LEFT: "left",
    ALIGN_RIGHT: "right",
    ALIGN_CENTER: "center"
}

export const VALUE_TYPES: any = {
    TEXT: "text",
    NUMBER: "number",
    DATE: "date",
    SWITCH: "switch",
    SELECT: "select",
    EDIT: "edit",
    VIEW: "view",
    BOOLEAN: "boolean",
    ICONBTN: "iconbtn",
    DOWNLOADBTN: "download_btn",
    ICONBTNS: "icon_btns"
}

export const GROUP_TABLE_HEADS = [
    { id: 'name', label: 'Name', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'status', label: 'Status', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.SWITCH, disabled: false },
    { id: 'edit', label: 'Edit', align: ALIGN_TYPES.ALIGN_CENTER, type: VALUE_TYPES.EDIT },
]

export const ACADEMIC_YEAR_TABLE_HEADS = [
    { id: 'academic_year', label: 'Academic Year', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'start_date', label: 'Start Date', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.DATE },
    { id: 'end_date', label: 'End Date', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.DATE },
    { id: 'status', label: 'Status', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.SWITCH },
    { id: 'edit', label: 'Edit', align: ALIGN_TYPES.ALIGN_CENTER, type: VALUE_TYPES.EDIT },
]

export const COMPANY_TABLE_HEADS = [
    { id: 'name', label: 'Name', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'address1', label: 'Address 1', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'address2', label: 'Address 2', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'po_box', label: 'Po Box', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'telephone1', label: 'Telephone 1', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'telephone2', label: 'Telephone 2', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'fax1', label: 'Fax 1', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'fax2', label: 'Fax 2', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'website', label: 'Website', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'edit', label: 'Edit', align: ALIGN_TYPES.ALIGN_CENTER, type: VALUE_TYPES.EDIT },
]

export const SCHOOL_TABLE_HEADS = [
    { id: 'name', label: 'Name', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'location', label: 'Location', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'head_office', label: 'Head Office', align: ALIGN_TYPES.ALIGN_CENTER, type: VALUE_TYPES.BOOLEAN },
    { id: 'school_id', label: 'School ID', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'tax_percentage', label: 'Tax %', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'currency', label: 'Currency', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'edit', label: 'Edit', align: ALIGN_TYPES.ALIGN_CENTER, type: VALUE_TYPES.EDIT },
]

export const USER_TABLE_HEADS = [
    { id: 'user_name', label: 'User Name', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'group_name', label: 'Group', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'user_tag', label: 'User Tag', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'employee_name', label: 'Employee Name', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'email', label: 'Email', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'status', label: 'Status', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.SWITCH, disabled: false },
    { id: 'edit', label: 'Edit', align: ALIGN_TYPES.ALIGN_CENTER, type: VALUE_TYPES.EDIT },
]

export const STUDENT_TABLE_HEADS = [
    { id: 'school', label: 'School', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'code', label: 'Student Code', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'first_name', label: 'First Name', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'last_name', label: 'Last Name', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'class', label: 'Class', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'division', label: 'Division', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'status', label: 'Status', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'edit', label: 'Edit', align: ALIGN_TYPES.ALIGN_CENTER, type: VALUE_TYPES.EDIT },
]

export const STUDENT_TRANSPORT_DETAIL_TABLE_HEADS = [
    { id: 'area', label: 'Area', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'zone', label: 'Zone', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'transport_type', label: 'Transport Type', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'morning_bus', label: 'Morning', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'evening_bus', label: 'Evening', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'start_date', label: 'Start Date', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.DATE },
    { id: 'end_date', label: 'End Date', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.DATE },
    { id: 'remarks', label: 'Remarks', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'status', label: 'Status', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.SWITCH, disabled: true },
    { id: 'edit', label: 'Edit', align: ALIGN_TYPES.ALIGN_CENTER, type: VALUE_TYPES.EDIT },
]

export const STUDENT_SOA_TABLE_HEADS = [
    // { id: 'academic_year', label: 'Academic Year', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    // { id: 'term', label: 'Term', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'date', label: 'Date', align: ALIGN_TYPES.ALIGN_CENTER, type: VALUE_TYPES.DATE },
    { id: 'transaction_type', label: 'Transaction Type', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'document_ref', label: 'Document Reference', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'debit_amount', label: 'Debit', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER },
    { id: 'credit_amount', label: 'Credit', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER },
    { id: 'running_balance', label: 'Running Balance', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER },
    { id: 'status', label: 'Status', align: ALIGN_TYPES.ALIGN_CENTER, type: VALUE_TYPES.TEXT },
    // { id: 'remarks', label: 'Narration', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
]

export const STUDENT_INVOICE_TABLE_HEADS = [
    { id: 'area', label: 'Area', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'period', label: 'Fee Month', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'term', label: 'Term', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'invoice_no', label: 'Inv No', align: ALIGN_TYPES.ALIGN_CENTER, type: VALUE_TYPES.NUMBER },
    { id: 'invoice_date', label: 'Inv Date', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.DATE },
    { id: 'debit_amount', label: 'Debit AED', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER },
    { id: 'vat_percentage', label: 'Vat', align: ALIGN_TYPES.ALIGN_CENTER, type: VALUE_TYPES.TEXT },
    { id: 'total_debit_amount', label: 'Total Debit AED', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER },
    { id: 'credit_amount', label: 'Credit AED', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER },
    { id: 'is_paid', label: 'Payment Status', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.BOOLEAN },
    { id: 'invoice_status', label: 'Status', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.SWITCH, disabled: false },
    { id: 'remarks', label: 'Remarks', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
]


export const DEPARTMENT_TABLE_HEADS = [
    { id: 'name', label: 'Name', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'status', label: 'Status', align: ALIGN_TYPES.ALIGN_CENTER, type: VALUE_TYPES.SWITCH },
    { id: 'edit', label: 'Edit', align: ALIGN_TYPES.ALIGN_CENTER, type: VALUE_TYPES.EDIT },
]

export const AREA_TABLE_HEADS = [
    { id: 'name', label: 'Name', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'status', label: 'Status', align: ALIGN_TYPES.ALIGN_CENTER, type: VALUE_TYPES.SWITCH },
    { id: 'edit', label: 'Edit', align: ALIGN_TYPES.ALIGN_CENTER, type: VALUE_TYPES.EDIT },
]

export const ZONE_TABLE_HEADS = [
    { id: 'name', label: 'Name', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'one_way_amount', label: 'One Way Amount', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER },
    { id: 'two_way_amount', label: 'Two Way Amount', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER },
    { id: 'edit', label: 'Edit', align: ALIGN_TYPES.ALIGN_CENTER, type: VALUE_TYPES.EDIT },
]

export const TRANSPORT_TYPE_TABLE_HEADS = [
    { id: 'type', label: 'Type', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'remark', label: 'Remark', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    // { id: 'type_number', label: 'Type Number', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER },
    { id: 'edit', label: 'Edit', align: ALIGN_TYPES.ALIGN_CENTER, type: VALUE_TYPES.EDIT },
]

export const FEES_TYPE_TABLE_HEADS = [
    { id: 'name', label: 'Name', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'invoice', label: 'Invoice', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'edit', label: 'Edit', align: ALIGN_TYPES.ALIGN_CENTER, type: VALUE_TYPES.EDIT },
]

export const FEES_SETUP_TABLE_HEADS = [
    { id: 'name', label: 'Name', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'no_of_months', label: 'No of months', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.NUMBER },
    { id: 'start_month', label: 'Start Month', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.DATE },
    { id: 'end_month', label: 'End Month', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.DATE },
    { id: 'edit', label: 'Edit', align: ALIGN_TYPES.ALIGN_CENTER, type: VALUE_TYPES.EDIT },
]

export const TRANSACTION_CODE_SETUPS_TABLE_HEADS = [
    { id: 'type', label: 'Type', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'starting_no', label: 'Starting No', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.NUMBER },
    { id: 'tag', label: 'Tag', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'edit', label: 'Edit', align: ALIGN_TYPES.ALIGN_CENTER, type: VALUE_TYPES.EDIT },
]


export const CLASS_PROMOTIONS_TABLE_HEADS = [
    { id: 'school', label: 'School', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'student', label: 'Student', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'class', label: 'Class', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'division', label: 'Division', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'academic_year', label: 'Academic Year', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
]

export const BUS_DETAILS_TABLE_HEADS = [
    { id: 'bus_number', label: 'Bus Number', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'edit', label: 'Edit', align: ALIGN_TYPES.ALIGN_CENTER, type: VALUE_TYPES.EDIT },
]

export const FINANCE_TRANSACTION_CODE_SETUPS_TABLE_HEADS = [
    { id: 'transaction', label: 'Transaction', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'short_code', label: 'Short Code', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'starting_no', label: 'Starting No', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.NUMBER },
    { id: 'reset_for_nfy', label: 'Reset for next financial year', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'edit', label: 'Edit', align: ALIGN_TYPES.ALIGN_CENTER, type: VALUE_TYPES.EDIT },
]

export const MODE_OF_PAY_TABLE_HEADS = [
    { id: 'mode_of_pay', label: 'Mode of pay', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'description', label: 'Description', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'status', label: 'Status', align: ALIGN_TYPES.ALIGN_CENTER, type: VALUE_TYPES.SWITCH },
    { id: 'edit', label: 'Edit', align: ALIGN_TYPES.ALIGN_CENTER, type: VALUE_TYPES.EDIT },
]

export const CURRENCY_TABLE_HEADS = [
    { id: 'country_code', label: 'Country Code', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'country_name', label: 'Country Name', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'currency_code', label: 'Currency Code', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'currency_description', label: 'Currency Description', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'convert_rate', label: 'Conver Rate', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER },
    { id: 'edit', label: 'Edit', align: ALIGN_TYPES.ALIGN_CENTER, type: VALUE_TYPES.EDIT },
]

export const CUSTOMER_TABLE_HEADS = [
    // { id: 'cgrp_no', label: 'CGRP No', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    // { id: 'cgrp_name', label: 'CGRP Name', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'status', label: 'Status', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'code', label: 'Code', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'customer_prefix', label: 'Prefix', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'name', label: 'Name', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'edit', label: 'Edit', align: ALIGN_TYPES.ALIGN_CENTER, type: VALUE_TYPES.EDIT },
]
export const SUPPLIER_TABLE_HEADS = [
    // { id: 'cgrp_no', label: 'CGRP No', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    // { id: 'cgrp_name', label: 'CGRP Name', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'status', label: 'Status', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'code', label: 'Code', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'supplier_prefix', label: 'Prefix', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'name', label: 'Name', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'edit', label: 'Edit', align: ALIGN_TYPES.ALIGN_CENTER, type: VALUE_TYPES.EDIT },
]
export const ACCOUNT_LEDGER_TABLE_HEADS = [
    { id: 'account_code', label: 'Account Code', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'account_name', label: 'Account Name', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'bank_doc_code', label: 'Bank Doc Code', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'no_of_digits_rep', label: 'No Of Digits REP', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'no_of_digits_pay', label: 'No Of Digits Pay', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'edit', label: 'Edit', align: ALIGN_TYPES.ALIGN_CENTER, type: VALUE_TYPES.EDIT },
]
export const BANK_DETAIL_TABLE_HEADS = [
    { id: 'bank_code', label: 'Bank Code', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'bank_name', label: 'Bank Name', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'ifsc_code', label: 'IFSC Code', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'country', label: 'Country', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'state', label: 'State', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'city', label: 'City', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'edit', label: 'Edit', align: ALIGN_TYPES.ALIGN_CENTER, type: VALUE_TYPES.EDIT },
]
export const MAIN_GROUP_LEDGER_TABLE_HEADS = [
    { id: 'group_id', label: 'Group ID', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'group_name', label: 'Group Name', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'edit', label: 'Edit', align: ALIGN_TYPES.ALIGN_CENTER, type: VALUE_TYPES.EDIT },
]

export const MAIN_GROUP_LEDGER_ACCOUNT_TABLE_HEADS = [
    { id: 'account_name', label: 'Account', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'school_name', label: 'School', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'edit', label: 'Edit', align: ALIGN_TYPES.ALIGN_CENTER, type: VALUE_TYPES.EDIT },
]
export const CHEQUE_TRANSACTION_SETUP_TABLE_HEADS = []
export const CASH_LEDGER_TABLE_HEADS = [
    { id: 'account_code', label: 'Account Code', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    // { id: 'city', label: 'City', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'edit', label: 'Edit', align: ALIGN_TYPES.ALIGN_CENTER, type: VALUE_TYPES.EDIT },
]

export const FORM_TABLE_HEADS = [
    { id: 'name', label: 'Form Name', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'download', label: 'Download', align: ALIGN_TYPES.ALIGN_CENTER, type: VALUE_TYPES.DOWNLOADBTN },
]

export const GROUP_HEADER_TABLE_HEADS = [
    { id: 'name', label: 'Name', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'code', label: 'Code', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'edit', label: 'Edit', align: ALIGN_TYPES.ALIGN_CENTER, type: VALUE_TYPES.EDIT },
]
export const MAIN_GROUP_TABLE_HEADS = [
    { id: 'name', label: 'Name', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'code', label: 'Code', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'edit', label: 'Edit', align: ALIGN_TYPES.ALIGN_CENTER, type: VALUE_TYPES.EDIT },
]
export const SUB_ACCOUNT_TABLE_HEADS = [
    { id: 'name', label: 'Name', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'code', label: 'Code', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'edit', label: 'Edit', align: ALIGN_TYPES.ALIGN_CENTER, type: VALUE_TYPES.EDIT },
]
export const ACCOUNT_TABLE_HEADS = [
    { id: 'name', label: 'Name', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'code', label: 'Code', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'edit', label: 'Edit', align: ALIGN_TYPES.ALIGN_CENTER, type: VALUE_TYPES.EDIT },
]

export const INVOICE_TABLE_HEADS = [
    { id: 'fee_type', label: 'Fee Type', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'school_name', label: 'School', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'student_name', label: 'Student Name', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'student_code', label: 'Student Code', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'invoice_no', label: 'Invoice No', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'invoice_date', label: 'Invoice Date', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.DATE },
    { id: 'period', label: 'Period', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'post_date', label: 'Post Date', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.DATE },
    { id: 'remarks', label: 'Remarks', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'status', label: 'Status', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'total_amount', label: 'Total Amount (AED)', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER },
    { id: 'is_paid', label: 'Payment Status', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.BOOLEAN },
    { id: 'edit', label: 'Edit', align: ALIGN_TYPES.ALIGN_CENTER, type: VALUE_TYPES.EDIT },
]

export const INVOICE_LINES_TABLE_HEADS = [
    { id: 'area', label: 'Area', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'description', label: 'Description', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'amount', label: 'Amount (AED)', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER },
    { id: 'vat_percentage', label: 'VAT Percentage', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.NUMBER },
    { id: 'vat_amount', label: 'VAT Amount', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER },
    { id: 'total_amount', label: 'Total Amount (AED)', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER },
]

export const INVOICE_LINES_CONTRACT_TABLE_HEADS = [
    { id: 'description', label: 'Particulars/Detail/Narration', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'debit_ledger_name', label: 'Debit Ledger', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'amount', label: 'Amount (AED)', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER },
    { id: 'vat_percentage', label: 'VAT', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.NUMBER },
    { id: 'vat_amount', label: 'Vat Amt', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER },
    { id: 'total_amount', label: 'Total AED', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER },
    { id: 'credit_ledger_name', label: 'Credit Ledger', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'credit_amount', label: 'Credit Amount', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER },

]

export const RECEIPT_TABLE_HEADS = [
    { id: 'fee_type', label: 'Fee Type', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'voucher_no', label: 'Voucher No', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'receipt_date', label: 'Date', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.DATE },
    { id: 'mode_of_pay', label: 'Payment Mode', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'bank_detail', label: 'Bank Name', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'school_name', label: 'School', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'student_code', label: 'Student Code', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'student_name', label: 'Student Name', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'receipt_status', label: 'Receipt Status', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'student_status', label: 'Student Status', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'debit_amount', label: 'Amount', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER },
    { id: 'term', label: 'Term', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'edit', label: 'Edit', align: ALIGN_TYPES.ALIGN_CENTER, type: VALUE_TYPES.EDIT },
]

export const RECEIPT_LINES_TABLE_HEADS = {
    "School Transport": [
        { id: 'narration', label: 'Narration', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
        { id: 'credit_amount', label: 'Credit Amt', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER },
        { id: 'total_amount', label: 'Total Amount', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER },
    ],
    "Other Fees": [
        { id: 'account_code', label: 'A/c Code', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
        { id: 'credit_ledger', label: 'Credit Ledger', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
        { id: 'narration', label: 'Narration', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
        { id: 'credit_amount', label: 'Amt AED', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER },
        { id: 'vat_amount', label: 'Vat@5%', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER },
        { id: 'total_amount', label: 'Total Amt', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER },
    ],
    "Account & Finance": [
        { id: 'account_code', label: 'A/c Code', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
        { id: 'credit_ledger', label: 'Credit Ledger', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
        { id: 'cheque_no', label: 'Chq No/Ref', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
        { id: 'cheque_date', label: 'Chq Dt', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
        { id: 'bank_detail', label: 'Bank', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
        { id: 'mode_of_pay', label: 'Mode', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
        { id: 'narration', label: 'Narration', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
        { id: 'credit_amount', label: 'Credit Amt', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER }
    ]
}

// export const JOURNAL_TABLE_HEADS = [
//     { id: 'id', label: 'Journal ID', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
//     { id: 'source', label: 'Source', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
//     { id: 'source_ref', label: 'Source Ref', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
//     { id: 'journal_date', label: 'Journal Date', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.DATE },
//     { id: 'debit_amount', label: 'Debit', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER },
//     { id: 'credit_amount', label: 'Credit', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER },
//     { id: 'debit_account', label: 'Debit Account', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
//     { id: 'credit_account', label: 'Credit Account', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
//     { id: 'inserted_at', label: 'Created Date', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.DATE },
//     // { id: 'edit', label: 'Edit', align: ALIGN_TYPES.ALIGN_CENTER, type: VALUE_TYPES.EDIT },
// ]

export const JOURNAL_TABLE_HEADS = [
    { id: 'journal_date', label: 'Date', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.DATE },
    { id: 'source', label: 'Voucher Ref', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'source_ref', label: 'Voucher No', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'narration', label: 'Narration', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'cheque_ref', label: 'Chq No./Inv', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'cheque_date', label: 'Chq. Dt/Inv Dt', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.DATE },
    { id: 'mode_of_pay', label: 'Mode of Payment', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'debit_amount', label: 'Debit', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER },
    { id: 'credit_amount', label: 'Credit', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER },
    { id: 'running_balance', label: 'Running Balance', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER },
    { id: 'icon_btns', label: 'Edit / Delete', align: ALIGN_TYPES.ALIGN_CENTER, type: VALUE_TYPES.ICONBTNS, buttons: ["edit", "delete"] },

]

export const CLASSES_TABLE_HEADS = [
    { id: 'name', label: 'Name', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'edit', label: 'Edit', align: ALIGN_TYPES.ALIGN_CENTER, type: VALUE_TYPES.EDIT },
]

export const TERMS_TABLE_HEADS = [
    { id: 'name', label: 'Name', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'start_date', label: 'Start Date', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.DATE },
    { id: 'end_date', label: 'End Date', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.DATE },
    { id: 'academic_year', label: 'Academic Year', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'edit', label: 'Edit', align: ALIGN_TYPES.ALIGN_CENTER, type: VALUE_TYPES.EDIT },
]

export const DISCOUNTS_TABLE_HEADS = [
    { id: 'type', label: 'Type', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'code', label: 'Student No', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'name', label: 'Student Name', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'from_date', label: 'From Date', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.DATE },
    { id: 'end_date', label: 'End Date', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.DATE },
    { id: 'discount_percentage', label: 'Discount %', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.TEXT },
    { id: 'created_by', label: 'Created By', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'inserted_at', label: 'Created Date', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.DATE },
    { id: 'remarks', label: 'Remarks', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'view', label: 'View', align: ALIGN_TYPES.ALIGN_CENTER, type: VALUE_TYPES.VIEW },
]

export const DAILY_FEE_COLLECTIONS_TABLE_HEADS = [
    { id: 'school_name', label: 'School', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'voucher_no', label: 'Voucher No', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'receipt_date', label: 'Receipt Date', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.DATE },
    { id: 'student_code', label: 'Student Code', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'student_name', label: 'Student Name', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'class', label: 'Class', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'division', label: 'Division', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'parent_name', label: 'Parent Name', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.TEXT },
    { id: 'mode_of_pay', label: 'Mode of pay', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.TEXT },
    { id: 'cheque_type', label: 'Cheque Type', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.TEXT },
    { id: 'cheque_no', label: 'Cheque No', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.TEXT },
    { id: 'cheque_date', label: 'Cheque Date', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.DATE },
    { id: 'bank_name', label: 'Bank Name', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.TEXT },
    { id: 'total_fees', label: 'Total Fees', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER },
    { id: 'term1', label: 'Term 1', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER },
    { id: 'term2', label: 'Term 2', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER },
    { id: 'term3', label: 'Term 3', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER },
    { id: 'created_by', label: 'Created By', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.TEXT },
    { id: 'created_date', label: 'Created Date', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.DATE },
    { id: 'bank_ref_no', label: 'Bank ref no', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.TEXT },
]

export const OUTSTANDING_FEES_TABLE_HEADS = [
    { id: 'student_code', label: 'Student Code', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'student_name', label: 'Student Name', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'class', label: 'Class', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'division', label: 'Division', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'term1', label: 'Term 1', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.NUMBER },
    { id: 'term2', label: 'Term 2', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.NUMBER },
    { id: 'term3', label: 'Term 3', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.NUMBER },
    { id: 'total_amount', label: 'Total Amount', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER },
    { id: 'father_name', label: 'Father Name', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'father_mobile', label: 'Father Mobile', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT },
    { id: 'mother_name', label: 'Mother Name', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.TEXT },
    { id: 'mother_mobile', label: 'Mother Mobile', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.TEXT },
    { id: 'father_email', label: 'Father Email', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.TEXT },
    { id: 'mother_email', label: 'Mother Email', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.TEXT },
    { id: 'status', label: 'Status', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.TEXT },
]

export const GO_TABLE_HEADERS = {
    "GROUP_TABLE_HEADS": GROUP_TABLE_HEADS,
    "DEPARTMENT_TABLE_HEADS": DEPARTMENT_TABLE_HEADS,
    "ACADEMIC_YEAR_TABLE_HEADS": ACADEMIC_YEAR_TABLE_HEADS,
    "COMPANY_TABLE_HEADS": COMPANY_TABLE_HEADS
};